import {
  ADMIN_COMPANIES_LOADED,
  ADMIN_COMPANIES_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  companies: null,
};

function adminCompany(state = initialState, action) {
  switch (action.type) {
    case ADMIN_COMPANIES_LOADED:
      return {
        ...state,
        companies: action.payload.companies,
      };
    case ADMIN_COMPANIES_CLEAR:
      return {
        ...state,
        companies: null,
      };
    default:
      return state;
  }
}

export default adminCompany;
